import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSearchIntelligence: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="search-intelligence, search-ai"><path d="M20 19.9999L16.1265 16.1265M16.1265 16.1265C14.8145 17.4385 13.002 18.25 11 18.25C6.99594 18.25 3.75 15.004 3.75 11C3.75 7.33517 6.46916 4.30548 10 3.81836M16.1265 16.1265C17.2162 15.0368 17.9606 13.6019 18.1816 12" stroke="currentColor" strokeWidth="1.5"/><path d="M16.4 2H15.6L14.6 4.6L12 5.6V6.4L14.6 7.4L15.6 10H16.4L17.4 7.4L20 6.4V5.6L17.4 4.6L16.4 2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSearchIntelligence;
